import { useCallback } from "react";

import { DataSourceRegistryPath } from "@/features/data-source/data-source-registry";
import { getDataSourceQueryArgs } from "@/features/data-source/data-source.utils";
import { dataSourceApi, TAG_DATA_SOURCE } from "@/store/services/data-source.service";
import { useAppDispatch } from "@/store/store.hooks";

type InvalidateCacheOptions = {
    query?: {
        name: DataSourceRegistryPath;
        parameters: Record<string, string | number | boolean>;
    };
};

const useInvalidateDataSourceCache = () => {
    const dispatch = useAppDispatch();

    /**
     * Invalidates the data source cache.
     *
     * @param options.query When provided, only the cache for the specified query will be invalidated.
     */
    const invalidateCache = useCallback(
        (options?: InvalidateCacheOptions) => {
            const { query } = options ?? {};

            let id: string | undefined;
            if (query) {
                const args = getDataSourceQueryArgs(query.name, query.parameters);
                id = JSON.stringify(args);
            }

            dispatch(dataSourceApi.util.invalidateTags([{ type: TAG_DATA_SOURCE, id }]));
        },
        [dispatch],
    );

    return invalidateCache;
};

export { useInvalidateDataSourceCache };
